enum Environment {
    LOCAL = 'LOCAL',
    DEV = 'DEV',
    STAGE = 'STAGE',
    PROD = 'PROD'
}

export { Environment };
